import { render, staticRenderFns } from "./BreakBoningReport.vue?vue&type=template&id=c6763b08"
import script from "./BreakBoningReport.vue?vue&type=script&setup=true&lang=js"
export * from "./BreakBoningReport.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports